
const initialState = {
  SupportingPMPData: [],
  loading: true,
  error: null,
};

const SupportingPMPReducer = (state = initialState, action = {}) => {
  const { type, payload } = action; 
  switch (type) {
    case "GET_SUPPORTING_PMP_REQUEST":
      return {
        ...state,
        SupportingPMPData: payload,
        loading: true,
        error: null,
      };
    case "GET_SUPPORTING_PMP_SUCCESS":
      return {
        ...state,
        SupportingPMPData: payload,
        loading: false,
        error: null,
      };
    case "GET_SUPPORTING_PMP_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default SupportingPMPReducer;
